import React, { useEffect, useState } from 'react';
import Map from './../Map';
import { loadMapApi } from '../map-utils';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { partnerListIsOpenSelector } from '../../../store/modules/ui/selectors';
import PartnerListToggler from '../../../views/PartnersLocator/PartnerListToggler';

interface IMapWrapper {
	classes: any;
}

const MapWrapper: React.FC<IMapWrapper> = ({ classes, ...props }) => {
	const [scriptLoaded, setScriptLoaded] = useState(false);

	const handleScriptLoaded = () => setScriptLoaded(true);

	useEffect(() => {
		const googleMapScript = loadMapApi();

		googleMapScript.addEventListener('load', handleScriptLoaded);

		return () => {
			googleMapScript.removeEventListener('load', handleScriptLoaded);
		};
	}, []);

	const contentShouldBeShifted = useSelector(partnerListIsOpenSelector);

	return (
		<div style={{ width: '100%', height: '100%' }}>
			{scriptLoaded && (
				<Box
					// className={clsx(classes.content, {
					// 	[classes.contentShift]: contentShouldBeShifted,
					// })}
					bgcolor="white"
					p={0}
					height="100%"
					position="relative"
					{...props}>
					<PartnerListToggler />
					<Map mapType={google.maps.MapTypeId.ROADMAP} mapTypeControl={true} />
				</Box>
			)}
		</div>
	);
};

export default MapWrapper;
